var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"element-title"},[_vm._v(" "+_vm._s(_vm.$t('settings.card-settings-options.global-parameters.subtitle'))+" ")]),_c('div',{staticClass:"element-description"},[_vm._v(" "+_vm._s(_vm.$t('settings.card-settings-options.global-parameters.subdescription'))+" ")]),_c('KnowledgeParameters')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }